<ng-container *ngIf="collectionsSelected$ | async as collectionsSelectedIds">
  <ng-container *ngIf="collection$ | async as collection">
    <app-accordion-item
      [colIndex]="colIndex"
      #item
      [expanded]="collectionOpened"
      *ngIf="filtered(collection.id, collectionsSelectedIds)"
      (expandedChange)="openCollection($event, collection)"
    >
      <div app-accordion-header>
        <div class="flex items-center justify-between">
          <svg-icon
            cdkDragHandle
            class="w-6 cursor-move p-1 text-theme-500"
            src="assets/icons/icon-grid.svg"
          ></svg-icon>
          <div class="mr-2 flex w-full items-center justify-start">
            <svg-icon
              [src]="item.expanded ? 'assets/icons/icon-files.svg' : 'assets/icons/icon-files-close.svg'"
              class="flex h-10 w-10 p-1 text-theme-500"
            ></svg-icon>
            <input
              [id]="
                collection.categoria_id +
                '-' +
                (collection.id ? collection.id + '-collection-input' : 'new-collection-input')
              "
              [formControl]="titleControl"
              class="w-full whitespace-nowrap border-0 px-2 text-md text-theme-950 placeholder:italic placeholder:text-theme-950 focus:font-semibold focus:outline-none focus:ring-0"
              [placeholder]="'trilhas.estudio.placeholder-nova-colecao' | translate"
              [ngClass]="{ '!text-red-500': titleControl.invalid }"
              (click)="blockClick($event)"
            />
          </div>
          <div *ngIf="item.expanded" class="flex justify-center">
            <div
              *ngIf="!!collection.id"
              class="mr-5 cursor-pointer rounded-full text-yellow-500 duration-300 hover:bg-yellow-500 hover:text-white hover:ring-4 hover:ring-yellow-200"
              app-tooltip
              [tooltip]="
                (collection.destaque ? 'trilhas.estudio.tooltip-remover-destaque' : 'trilhas.estudio.tooltip-destacar')
                  | translate
              "
              (click)="onHighlightCollection(collection); blockClick($event)"
            >
              <svg-icon
                [src]="collection.destaque ? 'assets/icons/star-filled.svg' : 'assets/icons/star-outline.svg'"
                class="flex h-10 w-10 p-1"
              ></svg-icon>
            </div>
            <button
              *ngIf="!collection.cursos?.length"
              class="mr-5"
              app-tooltip
              [tooltip]="'trilhas.estudio.tooltip-excluir-colecao' | translate"
              type="button"
              (click)="onDeleteCollection(collection.id)"
            >
              <svg-icon
                class="flex h-8 w-8 p-1 text-theme-500 duration-300 hover:text-theme-950"
                src="assets/icons/icon-trash.svg"
              ></svg-icon>
            </button>
            <div class="rounded-full rounded-r-none" [ngClass]="{ hidden: !showInput }">
              <input
                #searchInput
                app-input
                class="block !h-10 !w-96 !rounded-full !rounded-r-none !border-r-0 !leading-4 focus:!border-gray-200"
                type="search"
                [placeholder]="'trilhas.curso.pesquisar-curso' | translate"
                [formControl]="searchCtrl"
                (click)="blockClick($event)"
              />
            </div>
            <div *ngIf="collection.cursos?.length" class="mr-5 flex">
              <button
                app-input
                [ngClass]="{ '!rounded-l-none': showInput }"
                class="flex !h-10 !w-10 items-center justify-center !rounded-full !border-r-0 focus:!border-gray-200"
                (click)="onToggleInput(); blockClick($event); searchCtrl.reset()"
              >
                <svg-icon class="w-4 text-theme-500" src="assets/icons/icon-search.svg"></svg-icon>
              </button>
            </div>
            <div *ngIf="!!collection.id" class="mr-5 flex items-center justify-between gap-4">
              <div class="group">
                <button
                  type="button"
                  app-tooltip
                  [tooltip]="'trilhas.estudio.tooltip-add-curso' | translate"
                  class="rounded-full bg-[#fafafa] p-2 shadow-md ring-1 ring-theme-500 duration-300 group-hover:bg-theme-800 group-hover:ring-4 group-hover:ring-theme-200"
                  (click)="onOpenCourses($event)"
                >
                  <svg-icon
                    class="flex w-6 p-1 text-theme-500 duration-300 group-hover:text-theme-50"
                    src="assets/icons/icon-plus.svg"
                  ></svg-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div app-accordion-content>
        <div
          *ngIf="collection.cursos?.length; else empty"
          class="w-12/12 mb-2 flex items-center justify-between rounded-xl bg-white p-3 shadow-md"
        >
          <div class="ml-2 flex flex-wrap gap-12 py-8 md:ml-8 xl:ml-16">
            <ng-container *ngIf="(collection.cursos | filterCourse : searchCtrl.value).length > 0; else emptyFilter">
              <ng-container
                *ngFor="
                  let course of collection.cursos | filterCourse : searchCtrl.value;
                  let i = index;
                  let first = first;
                  let last = last
                "
                class="relative pl-8"
              >
                <ng-container *ngIf="coursesSelected$ | async as coursesSelectedIds">
                  <div *ngIf="filtered(course.id, coursesSelectedIds)" class="group/card relative h-full w-[20rem]">
                    <div
                      class="absolute z-20 hidden h-full w-full flex-col items-center rounded-xl bg-white/60 opacity-0 duration-300 hover:shadow-lg group-hover/card:opacity-100 lg:flex"
                    >
                      <ng-container *ngTemplateOutlet="menuOptions; context: { course, first, last }"></ng-container>
                    </div>
                    <div
                      class="absolute z-20 block h-full w-full lg:hidden"
                      (click)="onOpenCourseMenu(course.id)"
                      (clickOutside)="onCloseCourseMenu(course.id)"
                    >
                      <div
                        *ngIf="selectedCourseIdMobile === course.id"
                        class="h-full w-full rounded-xl bg-white/60 shadow-lg duration-300"
                      >
                        <ng-container *ngTemplateOutlet="menuOptions; context: { course, first, last }"> </ng-container>
                      </div>
                    </div>
                    <app-card class="w-[20rem] cursor-pointer !rounded-2xl">
                      <div app-card-content text-black class="mb-3">
                        <img
                          [src]="course.thumbnail"
                          onerror="this.src='../../../../../assets/images/default.png'"
                          alt="img_curso"
                          class="h-[210px] rounded-t-xl"
                        />
                      </div>
                      <hr app-divider />
                      <div app-card-footer class="relative flex flex-col items-start gap-1 rounded-b-xl pt-2">
                        <p class="text-md font-semibold">{{ course.titulo }}</p>
                      </div>
                    </app-card>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-template #emptyFilter>
        <div class="w-full p-5">
          <app-jumbotron class="!p-5" translate>trilhas.estudio.no-courses</app-jumbotron>
        </div>
      </ng-template>
      <ng-template #empty>
        <div class="w-full p-5">
          <app-jumbotron class="!p-5" translate>trilhas.estudio.colecao-vazia</app-jumbotron>
        </div>
      </ng-template>
    </app-accordion-item>
  </ng-container>
</ng-container>

<ng-template #menuOptions let-course="course" let-first="first" let-last="last">
  <svg-icon
    *ngIf="!first"
    src="assets/icons/icon-arrow-left.svg"
    class="absolute left-6 top-6 flex w-8 cursor-pointer rounded-lg bg-white p-1 text-theme-500 shadow-md duration-300 hover:bg-theme-500 hover:text-theme-contrast"
    (click)="onMove(course, -1)"
  >
  </svg-icon>
  <svg-icon
    *ngIf="!last"
    src="assets/icons/icon-arrow-right.svg"
    class="absolute right-6 top-6 flex w-8 cursor-pointer rounded-lg bg-white p-1 text-theme-500 shadow-md duration-300 hover:bg-theme-500 hover:text-theme-contrast"
    (click)="onMove(course, 1)"
  >
  </svg-icon>
  <!-- Botões de Ação -->
  <button
    translate
    app-icon-button
    class="group top-16 mx-5 my-2 w-[85%] bg-white font-semibold text-yellow-500 shadow-md duration-300 hover:bg-yellow-500 hover:text-white"
    type="button"
    (click)="onOpenCourses($event, course)"
  >
    <svg-icon
      class="mr-2 flex h-5 w-5 justify-center text-yellow-500 duration-300 group-hover:text-white"
      src="assets/icons/icon-pencil.svg"
    ></svg-icon>
    trilhas.estudio.curso.editar
  </button>
  <button
    translate
    app-icon-button
    class="group top-16 mx-5 my-2 w-[85%] bg-white font-semibold text-green-500 shadow-md duration-300 hover:bg-green-500 hover:text-white"
    type="button"
    (click)="onOpenEvents(course)"
  >
    <svg-icon
      class="mr-2 flex h-5 w-5 justify-center text-green-500 duration-300 group-hover:text-white"
      src="assets/icons/icon-calendar.svg"
    ></svg-icon>
    trilhas.evento.gerenciar
  </button>
  <button
    translate
    app-icon-button
    class="group top-16 mx-5 my-2 w-[85%] bg-white font-semibold text-blue-500 shadow-md duration-300 hover:bg-blue-500 hover:text-white"
    type="button"
    (click)="onSidenavStudioShowcase(course)"
  >
    <svg-icon
      class="mr-2 flex h-5 w-5 justify-center text-blue-500 duration-300 group-hover:text-white"
      src="assets/icons/icon-menu-showcase.svg"
    ></svg-icon>
    trilhas.estudio.vitrines
  </button>
  <button
    translate
    app-icon-button
    class="group top-16 mx-5 my-2 w-[85%] bg-white font-semibold text-red-500 shadow-md duration-300 hover:bg-red-500 hover:text-white"
    type="button"
    (click)="onOpenDuplicateCourses($event, course)"
  >
    <svg-icon
      class="mr-2 flex h-5 w-5 justify-center text-red-500 duration-300 group-hover:text-white"
      src="assets/icons/icon-copy-square.svg"
    ></svg-icon>
    trilhas.estudio.curso.duplicar
  </button>
</ng-template>
